import React, { type JSX } from 'react';

interface FormErrorsProps {
  messages: string|string[];
  isInfo?: boolean;
}

/**
 * Display either a single message or a list of validation errors.
 * Supports both a string or an array of strings.
 *
 * @example
 * <FormErrors messages={error}/>
 */
export const FormErrors = ({ messages, isInfo }: FormErrorsProps): JSX.Element => (
  <div className={`alert alert-${isInfo ? 'info' : 'danger' } py-2 px-3`}>
    { Array.isArray(messages)
      ? (
        <ul>{
          messages.map((msg: string, index: number) => (<li key={index}>{msg}</li>)) }
        </ul>
      )
      : <div dangerouslySetInnerHTML={{ __html: messages }}/>
    }
  </div>
);
